import { store } from '@/store';
import { showBindMobileDialog } from '@/utils/authSession';

const RESTRICTED_MSG = '账号已被限制发布';
const BIND_MOBILE_MSG = '请先绑定手机号';

/**
 * 禁言/限制发布：禁止发作品、改公开资料
 */
export function checkRestrictedAction(message = RESTRICTED_MSG) {
  if (store.state.user.restricted) {
    ElMessage({
      message,
      grouping: true,
      type: 'warning',
    });
    return false;
  }
  return true;
}

/**
 * 未绑手机：引导绑定
 */
export function checkMobileBound(user = {}) {
  const mobile = user.mobile || store.state.user.userInfo.mobile || store.state.user.personProfile.mobile;
  if (!mobile) {
    showBindMobileDialog();
    ElMessage({
      message: BIND_MOBILE_MSG,
      grouping: true,
      type: 'warning',
    });
    return false;
  }
  return true;
}

/**
 * 发布/改公开资料前置校验
 */
export function guardPublishOrProfileEdit(user = {}) {
  if (!checkMobileBound(user)) {
    return false;
  }
  return checkRestrictedAction();
}

export { RESTRICTED_MSG, BIND_MOBILE_MSG };
